import {
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  AccordionRoot,
  AccordionTrigger,
} from "../../../accordion/Accordion";
import {
  createColumnEditorTrigger,
  getHeaderActiveColumns,
  TD,
} from "../../../../util/table";
import { ModalProvider } from "../../../Modal/Modal";
import {
  TableBody,
  TableHead,
  TableRoot,
  TableRow,
} from "../../../Table/TableBasic";
import { useState } from "react";
import useActiveColumns from "../../../../hooks/useActiveColumns";
import { defaultInteresserColumns } from "../../../../config/admin/columnsConfig";
import IngenRegistreringer from "../../../pages/person/id/IngenRegistreringer";
import OpretNyButtonBlock from "../../../pages/person/id/OpretNyButtonBlock";
import { useQuery } from "@tanstack/react-query";
import { get } from "../../../../api/util";
import { SortBy } from "../../../../interfaces/table";
import { orderBy } from "../../../../util/orderBy";
import { adminInteresserFormConfig } from "../../../../config/form/admin/adminInteresserFormConfig";
import ColumnEditorModal from "@/components/column-editor/ColumnEditorModal";

interface Props {
  canWrite: boolean;
}

const defaultSortBy: SortBy<InteresserFields>[] = [
  {
    direction: "asc",
    field: "navn",
  },
];

const Interesser = ({ canWrite }: Props) => {
  const [sortBy, setSortBy] = useState<SortBy[]>(defaultSortBy);
  const [activeColumns, setActiveColumns] = useActiveColumns(
    `admin-kodelister-interesser-active-columns`,
    defaultInteresserColumns,
  );
  const { data, isPending, error, refetch } = useQuery<IInteresser[]>({
    queryKey: ["interesser"],
    queryFn: async function () {
      return get({ query: `interesser` });
    },
  });
  if (error) return <span>Der opstod en fejl</span>;
  if (isPending) return <span>Henter interesser...</span>;
  if (!data) {
    return (
      <IngenRegistreringer
        invalidateData={refetch}
        editConfig={canWrite ? adminInteresserFormConfig(undefined) : undefined}
      />
    );
  }

  return (
    <AccordionRoot>
      <AccordionItem value={"Interesser"} className="" isEmpty={false}>
        <AccordionHeader>
          <AccordionTrigger className="ps-3">
            <span>Interesser</span>
          </AccordionTrigger>
        </AccordionHeader>
        <AccordionContent className="c-card c-card--accordion mb-4">
          <ModalProvider>
            <TableRoot>
              <TableHead ColumnEditorTrigger={createColumnEditorTrigger()}>
                <>
                  {getHeaderActiveColumns(activeColumns, {
                    defaultSortBy,
                    setSortBy,
                    sortBy,
                  })}
                </>
              </TableHead>
              <TableBody>
                {orderBy(
                  data,
                  sortBy.map((s) => s.field),
                  sortBy.map((s) => s.direction),
                ).map((rowData, i) => {
                  return (
                    <TableRow
                      key={i}
                      editConfig={
                        canWrite
                          ? adminInteresserFormConfig(rowData.id)
                          : undefined
                      }
                      invalidateData={refetch}
                    >
                      <>
                        {activeColumns.map((col) => {
                          return (
                            <TD key={col.field} col={col} rowData={rowData} />
                          );
                        })}
                      </>
                    </TableRow>
                  );
                })}
              </TableBody>
            </TableRoot>
            <ColumnEditorModal
              defaultColumns={defaultInteresserColumns}
              columns={activeColumns}
              setActiveColumns={setActiveColumns}
            />
            <OpretNyButtonBlock
              editConfig={
                canWrite ? adminInteresserFormConfig(undefined) : undefined
              }
              invalidateData={refetch}
            />
          </ModalProvider>
        </AccordionContent>
      </AccordionItem>
    </AccordionRoot>
  );
};
export default Interesser;
